
import { connect } from 'react-redux';
import { change, Field, reduxForm, reset } from 'redux-form';
import classNames from 'classnames';
import { CancelButton, SubmitButtonModal } from '../../components/buttons';
import { renderTextArea, renderTextField } from '../../components/reduxFields';
import { getAllPatientInternalNotes, savePatientInternalNote, deletePatientInternalNote} from './actions/PatientActions';
import React from 'react';
import Dialog from 'material-ui/Dialog';
import SubString from 'add-ellipsis';
import { confirmAlert } from 'react-confirm-alert'; // Import
import { showFormatedDateandTime } from '../../actions/utilAction';
import SortingCustom from '../../components/SortingCustom';
import PaginatorCustom from '../../components/paginationCustom';
import Tooltip from '../../components/Tooltip';
import SmallLoader from '../../img/small-loader.gif';

const validate = (values) => {
  const errors = {};

  if (!values.title) {
    errors.title= 'Please enter note title'
  }
  if(!values.notes) {
    errors.notes= 'Please enter notes'
  } 
  return errors;
};


class PatientInternalNotesModal extends React.Component {
  constructor(props) {
    super(props);   
    this.state = {
      patientId: props.patientId ? props.patientId : null,
      noteId: null,
      deleteModal: false,
  }
  this.filter = {
      sort_Column: '',
      sort_Order: '',
      searchText: '',
  };
  this.setSortColumn = this.setSortColumn.bind(this); 
  }

  componentDidMount = () => {
    this.loadData()
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.saved_Notes && nextProps.saved_Notes !== this.props.saved_Notes) {       
        this.setState({noteId: null},()=>{
          this.props.dispatch(reset('PatientInternalNotesModal'));
        });
    }
  }

  loadData = (page_number) => {
      let searchObj = {
          sort_fields: this.filter.sort_Column || '',
          sort_order: this.filter.sort_Order || '',
          contain_filters: { patientId: this.props.patientId || null,SearchText: this.filter.searchText || null },
          pageNumber: page_number || 1,
      };   
      this.props.getAllPatientInternalNotes(searchObj, this.state.patientId)
  }

  setSortColumn(col_name, col_order) {
    if (col_name) {
        this.filter.sort_Column = col_name;
        this.filter.sort_Order = col_order;
        this.loadData();
    }
  }

  handleEditClick = (e, obj) => {    
    this.setState({noteId: obj.id},()=>{
      this.props.dispatch(change('PatientInternalNotesModal', `title`, obj.title || null));
      this.props.dispatch(change('PatientInternalNotesModal', `notes`, obj.notes || null));
    });
  }
 

  handleDeleteClick = (e, obj) => {
    this.setState({
        deleteModal : true
    })
    
    confirmAlert({
        title: 'Delete Selected Note',
        message: 'Are you sure you want to delete this note?',
        buttons: [
          {
            label: 'Yes',
            onClick: () => {
               this.props.deletePatientInternalNote(obj.id, this.state.patientId);
                this.setState({
                    deleteModal: false
                })
            }
          },
          {
            label: 'No',
            onClick: () => {
                this.setState({
                    deleteModal: false
                })
            }
          }
        ],
        closeOnClickOutside: false, //By Default it is true
        closeOnEscape: false,       //By Default it is true
      });
}

  handleClose = () => {
    this.props.closeDialog();
  }

  onSubmitHandler(formProps) {    
    let postData = {
      "id": this.state.noteId || 0,
      "patientId": this.props.patientId,
      "title": formProps.title,
      "notes":  formProps.notes,
      "isActive": true,      
    }    
    this.props.savePatientInternalNote(postData, this.props.patientId);    
  }
  
  renderData = (notesList) => {
    notesList = notesList || [];
    if (!notesList.length) {
        return (
            <tr>
                <td colSpan="5">
                    <div className="text-center no-record">{this.props.loading ? 'Loading please wait...' : 'No record found.'}</div>
                </td>
            </tr>
        );
    }
    return notesList.map((Obj, index) => {
        return (
            <tr key={index}>
                <td width="25%">{Obj.title}</td>
                <td width="30%">
                    {Obj.notes && Obj.notes.length > 0 ?
                        <Tooltip Description={Obj.notes} />
                        : null}
                    {Obj.notes != null && Obj.notes.length > 25 ? SubString(Obj.notes, 25) : Obj.notes != null ? Obj.notes : 'N/A'}
                </td>
                <td width="20%">{Obj.lastModifiedFirstName} {Obj.lastModifiedLastName}</td>
                <td width="20%">{showFormatedDateandTime(Obj.lastModifiedDate)}</td>                
                <td width="10%">
                    <button onClick={(e) => this.handleEditClick(e, Obj)} type="button" title="Edit" className="tbactionbtn bluefont"><i className="fa fa-pencil-square-o" aria-hidden="true"></i></button>
                    <button onClick={(e) => this.handleDeleteClick(e, Obj)} type="button" title="Delete" className="tbactionbtn redfont"><i className="fa fa-trash-o" aria-hidden="true"></i></button>
                </td>
            </tr>
        )
    })
}

  renderLoading() {
    return (
        <div>
            {this.props.loading ? (
                <div className="full_loader top0">
                    <div className="small-loader">
                        <img src={SmallLoader} alt="" />
                    </div>
                </div>
            ) : null}
        </div>
    );
}
  render() {
    const { handleSubmit } = this.props;
    const { patientInternalNotes } = this.props;
        let NotesList = (patientInternalNotes && patientInternalNotes.data) || [];
        let NotesMeta = (patientInternalNotes && patientInternalNotes.meta) || null
        const tableClass = classNames({
          'table': true,
          'table-striped': this.props.condensed,
          'table-bordered': this.props.bordered,
          'table-hover': true,
          'table-condensed': this.props.condensed,
          'customtable': true,
      });         
    return (
      <div>
        {!this.state.deleteModal && <Dialog
          className="custom_modal_new_appointment"
          title='Notes'
          modal={false}
          open={true}
          //actions={actions}
          autoScrollBodyContent={true}
        >
          {this.renderLoading()}
          <div className="row">
            <div className="col-sm-12">
              <form className="readmin-form custom_form" >
                <div className="row">
                  <div className="col-sm-12 require mt-30">
                    <Field                   
                    name="title"
                    label="Title"
                    type="text"
                    maxLength="100"                  
                    component={renderTextField} />
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12 require mt-30">
                    <Field 
                    name="notes"
                    label="Note"
                    type="text"
                    maxLength="4000"
                    component={renderTextArea} />
                  </div>
                </div>             
                <div className="row">
                    <div className="col-sm-12 pt20 btn_rt">
                      <CancelButton className="mr-15" onTouchTap={this.handleClose} />,
                      <SubmitButtonModal className="ml_15" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))} primary={true} label="Save" />
                    </div>
                  </div>
              </form>
            </div>
        </div>        

          <div className="table-responsive mt-15">
              <table className={tableClass}>
                  <thead>
                      <tr>
                          <th width="25%"><SortingCustom noSort={!NotesList.length} setSortColumn={this.setSortColumn} columnName='Title' displayName='Title' /></th>
                          <th width="30%">Description</th>
                          <th width="20%">Last Modified By</th>
                          <th width="20%">Last Modified Date</th>                          
                          <th width="10%">Actions</th>
                      </tr>
                  </thead>
                  <tbody>
                      {this.renderData(NotesList)}
                  </tbody>
              </table>
              {
                  NotesMeta && NotesMeta['totalPages']
                  ?
                  <PaginatorCustom data={NotesMeta} handlePageChange={(page_number) => this.loadData(page_number)} />
                  :
                  null
              }
          </div>        
        </Dialog>}
      </div>
    );
  }
}

const mapStateToProps = (state) => {     
  return {    
    loading: state.patient.loading,
    patientInternalNotes: state.patient.PatientInternalNotes !== null ? state.patient.PatientInternalNotes : [],
    saved_Notes: state.patient.saved_Notes,
    deleted_Notes: state.patient.deleted_Notes
  };
};

PatientInternalNotesModal = reduxForm({
  form: 'PatientInternalNotesModal', // a unique identifier for this form
  validate,  
})(PatientInternalNotesModal);

export default connect(mapStateToProps, { getAllPatientInternalNotes, savePatientInternalNote, deletePatientInternalNote })(PatientInternalNotesModal);



// WEBPACK FOOTER //
// ./src/modules/patients/PatientInternalNotes_Modal.js